module.exports = __webpack_public_path__ + "img/mexico.fed8e3c0.svg";